import { useRef } from 'react'
import { useLocalStorage } from 'react-use'
import { TransformedToken } from 'style-dictionary'
import { AnimatePresence, motion } from 'framer-motion'
import { ChevronDown, ChevronRight, getMotionProps } from '@dashboard/ui'

import { TableCell, TableRow } from '@/ui'
import { TokenStudioTokenRow } from './TokenStudioTokenRow'

interface TokenStudioGroupRowProps {
  name: string
  tokens: Record<string, TransformedToken>
}

const tokensMotionProps = getMotionProps({
  initial: { height: 0, opacity: 0 },
  animate: { height: 'auto', opacity: 1 },
  exit: { height: 0, opacity: 0 },
})

export const TokenStudioGroupRow = ({ name, tokens }: TokenStudioGroupRowProps) => {
  const ref = useRef<HTMLDivElement>(null)
  const [isCollapsed, setIsCollapsed] = useLocalStorage(`theme-studio.group-row.${name}`, false)

  const onClickToggleCollapse = () => {
    setIsCollapsed(isCollapsed ? false : true)
  }

  return (
    <>
      <TableRow ref={ref} className="sticky top-11 z-10 bg-fg-secondary font-semibold">
        <TableCell width={80} />
        <TableCell>{name}</TableCell>
        <TableCell />
        <TableCell />
        <TableCell />
        <TableCell width={128}>
          <button type="button" onClick={onClickToggleCollapse}>
            {isCollapsed ? <ChevronRight /> : <ChevronDown />}
          </button>
        </TableCell>
      </TableRow>
      <div>
        <AnimatePresence initial={false}>
          {!isCollapsed && (
            <motion.div {...tokensMotionProps} className="overflow-hidden">
              {Object.entries(tokens).map(([key, token]) => (
                <TokenStudioTokenRow key={`token-${key}`} token={token} />
              ))}
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </>
  )
}
